module.exports = __webpack_public_path__ + "img/Slack_RGB_White.9b690f20.svg";